import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { editQuantityOfItem } from 'swag-client-common/redux/cart/cart.actions';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { cartItemToEditSelector, itemVariantsSelector, orderIdtSelector, sizeSelector, minQuantSelector, maxQuantSelector, relatedMinQuantSelector, isRelatedItemByMinQuantSelector, stockLevelsByVariantSkuSelector, sharedItemInfoSelector, sharedVariantsSelector, quantIncrementSelector } from '../../../../../redux/cart/cart.selectors';
import { EditQuantity } from './edit-quantity';
const mapStateToProps = createStructuredSelector({
  item: cartItemToEditSelector,
  variants: itemVariantsSelector,
  orderId: orderIdtSelector,
  size: sizeSelector,
  maxQuant: maxQuantSelector,
  relatedMinQuant: relatedMinQuantSelector,
  isRelated: isRelatedItemByMinQuantSelector,
  stockLevelsByVariantSku: stockLevelsByVariantSkuSelector,
  sharedItemInfo: sharedItemInfoSelector,
  sharedVariants: sharedVariantsSelector,
  minQuant: minQuantSelector,
  quantIncrement: quantIncrementSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(hidePopup()),
  onSave: (item, recalculateOrder) => dispatch(editQuantityOfItem({
    item,
    recalculateOrder
  }))
});
export default connect(mapStateToProps, mapDispatchToProps)(EditQuantity);